import { action } from 'sky-engine/api/index'

import { DELIVERY_PROJECT_MNG, PLAN_MNG } from '@/api/apiModules'
import lang from '@/lang'

import dictionary from '@/utils/dictionary'
export default {
  viewType: 'table',
  module: DELIVERY_PROJECT_MNG,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  params: {
    isTemplate: false,
    flowStatus: 'MDR_DEPLOY_TO_BE_CREATE'
  },
  refreshInterval: 20000,
  // relationSearch: true,
  // // allowStatus: {},
  toolbar: {
    searchWidth: 360,
    moreBtnWidth: 160,
    // hasColAdjustment: true,
    searchPlaceholder: 'pocMng.searchPlaceholder',
    searchFieldNameArr: ['customer', 'projectCode', 'projectName'],
    items: [],
    tips: {
      label: '注：此处展示系统主动推送的项目单子',
      type: 'info'
    }
  },
  cb: function() {
    action(DELIVERY_PROJECT_MNG, '/list', this.listQuery).then(result => {
      if (result.data.content.groupList) {
        for (let index = 0; index < this.view.columns.length; index++) {
          const element = this.view.columns[index]
          if (result.data.content.groupList.hasOwnProperty(element.props.prop)) {
            var letaa = result.data.content.groupList[element.props.prop]
            this.view.columns[index].props.filters = letaa
          }
        }
      }
    })
  },
  class: 'sk-custom-table-right-page',
  view: {
    'cell-class-name': 'sk-customize-cell-hight',
    columns: [
      {
        props: {
          label: 'pocMng.industry',
          prop: 'industryId',
          width: 110
        },
        dataType: 'custom',
        custom(row, _h, value, e) {
          return row.industryName
        },
        filter: true,
        url: `industry/list`,
        params: {
          limit: 100,
          page: 0
        }
      },
      {
        props: {
          label: 'pocMng.projectName',
          prop: 'projectName',
          sortField: 'projectName'
        }
      },
      {
        props: {
          label: 'pocMng.customer',
          prop: 'customer',
          sortField: 'customer',
          width: 255
        }
      },
      {
        props: {
          label: '管理者',
          prop: 'salesLeaderIds',
          sortField: 'salesLeaderIds',
          width: 100
        },
        dataType: 'custom',
        custom: function(row, h, value, e) {
          if (!row.salesLeaderLabelList) {
            return ''
          }
          const nameArr = row.salesLeaderLabelList.map(item => item.label).join(', ')
          return <span>{nameArr}</span>
        },
        filter: true,
        url: `/delivery/project/salesLeader/list`,
        params: {
          hasTemplate: false,
          flowStatusList: ['MDR_DEPLOY_TO_BE_CREATE']
        }
      },
      // {
      //   props: {
      //     label: 'pocMng.sales',
      //     prop: 'salesName',
      //     sortField: 'salesName',
      //     width: 100
      //   }
      // },
      {
        props: {
          label: 'pocMng.presales',
          prop: 'presalesId',
          sortField: 'presalesId',
          width: 100
        },
        filter: true,
        url: `/delivery/project/preSales/list`,
        params: {
          hasTemplate: false,
          flowStatusList: ['MDR_DEPLOY_TO_BE_CREATE']
        }
      },
      {
        props: {
          label: 'pocMng.postsales',
          prop: 'postsalesIds',
          sortField: 'postsalesIds',
          width: 100
        },
        dataType: 'custom',
        custom: function(row, h, value, e) {
          if (!row.postsalesIdLabelList) {
            return ''
          }
          const nameArr = row.postsalesIdLabelList.map(item => item.label).join(', ')
          return <span>{nameArr}</span>
        },
        filter: true,
        url: `/delivery/project/postSales/list`,
        params: {
          hasTemplate: false,
          flowStatusList: ['MDR_DEPLOY_TO_BE_CREATE']
        }
      },
      {
        props: {
          label: 'pocMng.pocState',
          prop: 'flowStatus',
          sortField: 'flowStatus',
          width: 145
        },
        dataType: 'custom',
        custom: function(data, h) {
          if (!data) {
            return
          }
          if (dictionary['deliveryFlowStatus'][data.flowStatus].type) {
            const renderItem = [
              <el-tag type={dictionary['deliveryFlowStatus'][data.flowStatus].type}>
                {lang.t(dictionary['deliveryFlowStatus'][data.flowStatus].label)}
              </el-tag>
            ]
            return renderItem
          } else {
            const renderItem = [
              <el-tag color={dictionary['deliveryFlowStatus'][data.flowStatus].color}>
                {lang.t(dictionary['deliveryFlowStatus'][data.flowStatus].label)}
              </el-tag>
            ]
            return renderItem
          }
        }
      },
      {
        props: {
          label: 'pocMng.projectSourceType',
          prop: 'projectSourceType',
          sortField: 'projectSourceType',
          width: 100
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'projectSourceType'
      },
      {
        props: {
          label: 'pocMng.createTime',
          prop: 'createTime',
          sortable: 'custom',
          sortField: 'createTime',
          width: 125
        },
        //dataType: 'date'
        dataType: 'custom',
        custom: function(row, h, value, e) {
          var date = new Date(value)
          var Y = date.getFullYear() + '-'
          var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
          var D = date.getDate() + 1 > 10 ? date.getDate() : '0' + date.getDate()
          return <span>{Y + M + D}</span>
        }
      },
      {
        props: {
          label: 'pocMng.createUserName',
          prop: 'createUserName',
          sortField: 'createUserName',
          width: 105
        }
      },

      {
        props: {
          label: 'pocMng.projectPlan',
          prop: 'planFlag',
          width: 105
        },
        dataType: 'custom',
        custom: function(data, h) {
          if (!data) {
            return
          }

          let vNode = [
            <div class="wsp-display-flex-center">
              <div class="wsp-width-20 el-icon-download"></div>
              <div class="wsp-width-80">
                <div
                  class="sk-link--normal  wsp-width-100"
                  on-click={$event => {
                    this.$store.dispatch('customDownloadDocument', {
                      module: PLAN_MNG,
                      params: {
                        id: data.id
                      },
                      action: 'downloadPlan'
                    })
                  }}
                >
                  <span>Word</span>
                </div>
                <div
                  class="sk-link--normal wsp-width-100"
                  on-click={$event => {
                    this.$store.dispatch('customDownloadDocument', {
                      module: PLAN_MNG,
                      params: {
                        id: data.id
                      },
                      action: 'downloadPlanExcel'
                    })
                  }}
                >
                  <span>Excel</span>
                </div>
              </div>
            </div>
          ]

          if (data.planFlag === 'Y') {
            return vNode
          }
          if (data.planFlag === 'N') {
            return <span>未生成</span>
          }
          return
        }
      },
      {
        //操作
        props: {
          showBtnNum: '2',
          fixed: null
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-delete',
        label: '按模版创建',
        command: 'CreateDdProjectFromTemOnToBe',
        name: 'CreateDdProjectFromTemOnToBe'
      },
      {
        icon: 'el-icon-edit',
        label: '全新交付',
        command: 'CreateNewDdProject',
        name: 'CreateNewDdProject'
      }
    ]
  }
}
